var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7609_161684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 14.6644C8.87532 14.6655 9.74254 14.4935 10.5515 14.1584C11.3605 13.8233 12.0953 13.3317 12.7137 12.7117C13.3336 12.0933 13.8253 11.3585 14.1604 10.5496C14.4955 9.74058 14.6674 8.87336 14.6663 7.99773C14.6674 7.12209 14.4955 6.25487 14.1604 5.44589C13.8253 4.63691 13.3336 3.90212 12.7137 3.28373C12.0953 2.66378 11.3605 2.17213 10.5515 1.83703C9.74254 1.50193 8.87532 1.32998 7.99968 1.33106C7.12404 1.32998 6.25682 1.50193 5.44784 1.83703C4.63886 2.17213 3.90407 2.66378 3.28568 3.28373C2.66573 3.90212 2.17409 4.63691 1.83898 5.44589C1.50388 6.25487 1.33193 7.12209 1.33301 7.99773C1.33193 8.87336 1.50388 9.74058 1.83898 10.5496C2.17409 11.3585 2.66573 12.0933 3.28568 12.7117C3.90407 13.3317 4.63886 13.8233 5.44784 14.1584C6.25682 14.4935 7.12404 14.6655 7.99968 14.6644Z",
    stroke: "#17A83D",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 7.99756L7.33301 9.99756L11.333 5.99756",
    stroke: "#17A83D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7609_161684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/CheckmarkIcon.4e260306670e761ad816c35c863e041c.svg";
export { ForwardRef as ReactComponent };